import { useTranslation } from "@/hooks/useTranslation"
import { Form } from "@/organisms/Form"
import {
  getAiPolicyScope,
  getConditionPlatformError
} from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"

import styles from "./LiveRuleField.module.scss"

import type { Rule } from "@/atoms"
import type { PlatformFieldProps } from "./LiveRuleField.types"

const SCOPE_LIST = "specific_resources"

// The rule's condition, with why the scope's platforms cannot enforce it as its
// error, checked again as the scope changes
export const PlatformField = ({ name }: PlatformFieldProps) => {
  const { t } = useTranslation()
  const { form } = Form.useForm()
  const scope = Form.useWatch(SCOPE_LIST, form)
  // A dependency on the list alone misses a change of one of its values
  const scopeFields = [
    "resources",
    ...(scope ?? []).flatMap((_: unknown, index: number) => [
      [SCOPE_LIST, index, "type"],
      [SCOPE_LIST, index, "value"]
    ])
  ]
  const platformRules: Rule[] = [
    ({ getFieldValue }) => ({
      validator: async (_, condition) => {
        const { platforms = [] } = getAiPolicyScope({
          resources: getFieldValue("resources"),
          specific_resources: getFieldValue(SCOPE_LIST)
        })
        const error = getConditionPlatformError(condition, platforms)

        if (error) throw new Error(t(error))
      }
    })
  ]

  return (
    <Form.Item
      name={[name, "condition"]}
      dependencies={scopeFields}
      rules={platformRules}
      className={styles.errorOnly}
    />
  )
}
